import React from "react";

import Header from "../layout/Header";
import "./index.scss";

const SlideRejoindre = () => {
  return (
    <div className="slide-rejoindre">
      <Header />
      <div className="slide-rejoindre-container ">
        <div className="row w-100">
          <div className="col-lg-1"></div>
          <div className="col-lg-7">
            {" "}
            <div className="slide-rejoindre-container-content ">
              <h1 className="slide-rejoindre-container-content-title">
                Donnez du sens à votre quotidien
              </h1>
              <p className="slide-rejoindre-container-content-description">
                Chez La fondation JM, bénévoles et salariés ont un engagement
                commun : la solidarité. Notre politique de ressources humaines
                vous propose d’incarner cette valeur en travaillant à nos côtés.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideRejoindre;
